package com.iregained.eventapp.components.sections.event_details.styles

import com.iregained.eventapp.theme.toSitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.px

val WorkflowContainerStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .backgroundColor(Colors.White) // 60% Dominant Color
}

val WorkflowGridContainerStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .maxWidth(1440.px)
        .gap(80.px)
}

val WorkflowRowGridStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .gap(40.px)
}

val WorkflowImageBoxStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .aspectRatio(16, 9) // 1. Forces every single box to be identically sized
        .backgroundColor(Colors.White) // 2. Creates a clean frame color for any empty space
        .borderRadius(16.px)
        .overflow(Overflow.Hidden)
        .boxShadow(
            offsetX = 0.px,
            offsetY = 10.px,
            blurRadius = 30.px,
            color = Colors.Black.copy(alpha = 10)
        )
}

val WorkflowImageStyle = CssStyle.base {
    Modifier
        .fillMaxSize()
        // 3. The Magic Bullet: Shows 100% of the image, NEVER crops, just fits it inside the box
        .objectFit(ObjectFit.Contain)
}

val WorkflowContentColumnStyle = CssStyle.base {
    Modifier
        .fillMaxSize()
}

val WorkflowOverlineStyle = CssStyle.base {
    Modifier
        .fontSize(14.px)
        .fontWeight(FontWeight.Bold)
        .color(colorMode.toSitePalette().brand.primary) // Teal Accent
        .textTransform(TextTransform.Uppercase)
        .letterSpacing(1.5.px)
        .margin(bottom = 12.px)
}

val WorkflowStepTitleStyle = CssStyle.base {
    Modifier
        .fontSize(32.px)
        .fontWeight(FontWeight.Bold)
        .color(colorMode.toSitePalette().custom.darkText)
        .margin(bottom = 24.px)
        .lineHeight(1.2)
}

val WorkflowStepDescStyle = CssStyle.base {
    Modifier
        .fontSize(18.px)
        .color(colorMode.toSitePalette().custom.darkText.toRgb())
        .lineHeight(1.6)
}